module.exports = {
	"id": "KN",
	"name": "Saint Kitts and Nevis",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.013316,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.03329,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.006658,
			"32": null,
			"33": 0.006658,
			"34": 0.006658,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.006658,
			"39": 0.019974,
			"40": 0.006658,
			"41": 0.013316,
			"42": null,
			"43": 0.046606,
			"44": 0.013316,
			"45": 0.039948,
			"46": 0.03329,
			"47": 0.039948,
			"48": 0.013316,
			"49": 1.478076,
			"50": 0.086554,
			"51": 0.525982,
			"52": 0.559272,
			"53": 31.439076,
			"54": 8.02289,
			"55": 0.06658,
			"56": 0.03329,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.013316,
			"35": null,
			"36": 0.019974,
			"37": null,
			"38": 0.013316,
			"39": 0.03329,
			"40": null,
			"41": null,
			"42": 0.019974,
			"43": 0.026632,
			"44": 0.006658,
			"45": 0.193082,
			"46": 0.019974,
			"47": 0.246346,
			"48": 0.372848,
			"49": 4.06138,
			"50": 0.073238,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.013316,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.013316,
			"36": null,
			"37": 0.206398,
			"38": null,
			"39": 0.013316,
			"40": 0.825592,
			"41": 0.059922,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.026632
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.126502,
			"6": null,
			"7": 0.006658,
			"8": 0.16645,
			"9": 0.226372,
			"10": 3.202498,
			"3.1": null,
			"3.2": null,
			"5.1": 0.06658,
			"6.1": 0.086554,
			"7.1": null,
			"9.1": 1.344916
		},
		"ios_saf": {
			"8": 0,
			"10": 5.90387525812,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.159102606682,
			"8.1-8.4": 0.293935324209,
			"9.0-9.2": 0.140226026228,
			"9.3": 2.13934578476
		},
		"android": {
			"3": 0,
			"4": 0.0602502299742,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00753127874677,
			"4.1": 0.217331186693,
			"4.2-4.3": 0.543327966731,
			"4.4": 1.24588868411,
			"4.4.3-4.4.4": 1.25664765375
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.106528,
			"9": 0.06658,
			"10": 0.446086,
			"11": 3.322342,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0112898056886,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000313605713572
		},
		"edge": {
			"12": 0.179766,
			"13": 1.078596,
			"14": 2.869598
		},
		"ie_mob": {
			"10": 0.0942067887324,
			"11": 0.383556211268
		},
		"bb": {
			"7": 0.08436025,
			"10": null
		},
		"samsung": {
			"0": 4.005859
		},
		"and_uc": {
			"0": 0.337441
		},
		"op_mini": {
			"0": 0.152105588598
		},
		"and_chr": {
			"0": 19.501629
		},
		"and_ff": {
			"0": 0.03341
		}
	},
	"total": 98.63750925
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KN.json
 ** module id = 565
 ** module chunks = 0
 **/